import {
    SET_HIDDEN_HOME_WIDGETS,
} from './homeWidgetConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialState = {
    hiddenHomeWidgets: [],
};

export function homeWidgets(state = initialState, action) {
    switch (action.type) {
        case SET_HIDDEN_HOME_WIDGETS:
            return setValue(state, ['hiddenHomeWidgets'], action.hiddenHomeWidgets);
        default:
            return state;
    }
}
